import React from "react";

const getCurrentYear = () => {
  return new Date().getFullYear();
};

export const Footer = () => {
  return (
    <div className="footer">
      <div className="footer-section">
        <a
          href="https://www.rebill.to/politica-de-privacidad"
          target="_blank"
          rel="noreferrer"
        >
          Política de Privacidad
        </a>
        <a
          href="https://www.rebill.to/terminos-y-condiciones-comercios"
          target="_blank"
          rel="noreferrer"
        >
          Términos y Condiciones
        </a>
      </div>
      <div className="footer-section">
        © {getCurrentYear()} Rebill, LTD. Todos los derechos reservados.
      </div>
    </div>
  );
};
